import { ContentCard, LoadingShim } from "@narmi/design_system";
import styles from "./SidebarLink.module.css";
import type { ReactNode } from "react";

interface SidebarLinkProps {
  icon: ReactNode;
  onClick: () => void;
  subtitle: string;
  title: string;
  disabled?: boolean;
  isLoading?: boolean;
}

function SidebarLink({ icon, onClick, subtitle, title, disabled, isLoading }: SidebarLinkProps) {
  // The launching card is also disabled by its parent (all cards are), so `disabled`
  // alone covers the loading case; `isLoading` only drives the spinner.
  const isDisabled = disabled === true || isLoading === true;
  return (
    <div className={styles.cardShell}>
      <ContentCard
        kind="button"
        radiusSize="l"
        paddingSize="m"
        onClick={onClick}
        disabled={isDisabled}
      >
        <LoadingShim isLoading={!!isLoading}>
          <div className={styles.content}>
            <div className={styles.iconContainer}>{icon}</div>
            <div className={styles.textContainer}>
              <div className={styles.title}>{title}</div>
              <div className={styles.subtitle}>{subtitle}</div>
            </div>
            <span className={`narmi-icon-chevron-right ${styles.chevron}`} aria-hidden="true" />
          </div>
        </LoadingShim>
      </ContentCard>
    </div>
  );
}

export { SidebarLink };
